import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { switchMap, map, catchError, take, finalize } from 'rxjs/operators';
import * as TMechanicDashboardActions from './mechanic-dashboard.actions';
import { TMechanicDashboardActionType } from './mechanic-status-dashboard.models';
import { AppNotificationUtilClass, MachineMaintenanceDataService } from '@monorepo/services';

@Injectable({ providedIn: 'root' })
export class MechanicDashboardEffects {
  constructor(
    private actions$: Actions,
    private mmDataService: MachineMaintenanceDataService,
    private APIHelper: AppNotificationUtilClass,
  ) {}

  getMechanicDashboard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TMechanicDashboardActionType.GetMechanicDashboardInfo),
      switchMap((action: TMechanicDashboardActions.GetMechanicDashboardInfo) =>
        from(this.APIHelper.presentLoading()).pipe(
          map((loaderEl) => {
            return [loaderEl, action] as const;
          }),
        ),
      ),
      switchMap(([loaderEl, action]) =>
        this.mmDataService.fetchMechanicDashboardData().pipe(
          finalize(() => {
            this.APIHelper.dismissLoadingV2(loaderEl);
          }),
          map((res) => new TMechanicDashboardActions.GetMechanicDashboardInfoSuccess(res.employeeLoginActivityDetails)),
          catchError(() => {
            return of(new TMechanicDashboardActions.GetMechanicDashboardInfoFailure());
          }),
        ),
      ),
    ),
  );
}
